// src/data/exercises/L3_04.js

const accountOptions = [
  '旅費', '仮払金', '現金', '売上', '通信費'];

export const L3_04 = {
  title: '簿記　3級（第219-4回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

     parts: [
        { type: 'ruby', text: '従業員', ruby: 'じゅうぎょういん' },
        { type: 'text', value: 'が' },
        { type: 'ruby', text: '出張', ruby: 'しゅっちょう' },
        { type: 'text', value: 'から' },
        { type: 'ruby', text: '戻', ruby: 'もど' },
        { type: 'text', value: 'り、' },
        { type: 'ruby', text: '概算払', ruby: 'がいさんばら' },
        { type: 'text', value: 'いしていた' },
        { type: 'ruby', text: '出張費', ruby: 'しゅっちょうひ' },
        { type: 'text', value: '￥150,000を' },
        { type: 'ruby', text: '精算', ruby: 'せいさん' },
        { type: 'text', value: 'したところ、' },
        { type: 'ruby', text: '旅費', ruby: 'りょひ' },
        { type: 'text', value: 'は￥123,000との' },
        { type: 'ruby', text: '報告', ruby: 'ほうこく' },
        { type: 'text', value: 'を' },
        { type: 'ruby', text: '受', ruby: 'う' },
        { type: 'text', value: 'け、' },
        { type: 'ruby', text: '残額', ruby: 'ざんがく' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '現金', ruby: 'げんきん' },
        { type: 'text', value: 'で' },
        { type: 'ruby', text: '受', ruby: 'う' },
        { type: 'text', value: 'け' },
        { type: 'ruby', text: '取', ruby: 'と' },
        { type: 'text', value: 'った。' }
    ]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '旅費', debitAmount: 123000, creditAccount: '仮払金', creditAmount: 150000 },
        { debitAccount: '現金', debitAmount: 27000, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '概算払いしていた出張費￥150,000を精算したところ \n' },
          { type: 'text', value: '①概算払いしていたい・・・精算した \n' },
          { type: 'text', value: '概算払いを精算したので、仮払金が減少（マイナス）します。 \n' },
          { type: 'styled', value: '仮払金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '旅費は￥123,000との報告を受け \n' },
          { type: 'text', value: '②旅費で￥123,000との報告なので、旅費が発生します。\n' },
          { type: 'styled', value: '旅費の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '残額は現金で受け取った。 \n' },
          { type: 'text', value: '③現金で受け取ったので、現金が増加（プラス）します。 \n' },
          { type: 'text', value: '残額は150,000－旅費＝？ \n' },
          { type: 'styled', value: '現金の増加は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
                ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`概算払いしていた出張費￥150,000を精算したところ
①概算払いしていたい・・・精算した
概算払いを精算したので、仮払金が減少（マイナス）します。

旅費は￥123,000との報告を受け
②旅費で￥123,000との報告なので、旅費が発生します。

残額は現金で受け取った。
③現金で受け取ったので、現金が増加（プラス）します。
残額は150,000－旅費＝？

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '概算払いしていた出張費￥150,000を精算したところ \n' },
          { type: 'text', value: '①概算払いしていたい・・・精算した \n' },
          { type: 'text', value: '概算払いを精算したので、仮払金が減少（マイナス）します。 \n' },
          { type: 'styled', value: '仮払金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '旅費は￥123,000との報告を受け \n' },
          { type: 'text', value: '②旅費で￥123,000との報告なので、旅費が発生します。\n' },
          { type: 'styled', value: '旅費の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '残額は現金で受け取った。 \n' },
          { type: 'text', value: '③現金で受け取ったので、現金が増加（プラス）します。 \n' },
          { type: 'text', value: '残額は150,000－旅費＝？ \n' },
          { type: 'styled', value: '現金の増加は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
                ]
          }
        ],
       
      },
    },
  ],
};